import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

const el = document.getElementById('ipoteka-welcome-root');
if (el) {
    const userId = el.dataset.userId ?? '';
    const csrf = el.dataset.csrf ?? '';
    createRoot(el).render(
        <StrictMode>
            <App userId={userId} csrf={csrf} />
        </StrictMode>,
    );
}
